const inicialState = {
    laminas: [],
    moverDisabled: true,
    modal: false,
    novasLaminas: false
  };
  
  export default inicialState;


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/store/kanban.state.js